<template>
  <v-container fluid class="home pt-0">
    <v-row justify="center" class="home-bg-color">
      <v-col cols="12" md="10" xl="8">
        <v-radio-group v-model="toggleAccess" row @change="reloadTables" v-if="isManager" class="toggle-group mt-0" hide-details>
          <v-radio
              :label="$t('book/dashboard:home.assigned-facilities')"
              :value="own"
              color="white"
          />
          <v-radio
              :label="$t('book/dashboard:home.all-facilities')"
              :value="all"
              color="white"
          />
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row justify="center" class="home-main pa-5 pa-md-0">
      <v-col cols="12" md="10" xl="8" class="pt-5">
        <h5 class="white--text font-weight-bold mb-5 i18n" data-i18n="[html]content.body">
          {{ $t('book/dashboard:home.titles.header-part-1') }}
          &trade;
          {{ $t('book/dashboard:home.titles.header-part-2') }}
        </h5>

        <v-expansion-panels flat tile multiple>
          <v-row>
            <v-col cols="12">
              <!-- Urgent Processes -->
              <ExpansionPanelDataTablePaginated
                  ref="urgentProcesses"
                  countColor="scaleRed"
                  :headerTextFirstRow="$t('book/dashboard:home.urgent-process')"
                  :headerTextSecondRow="$t('common:process_plural')"
                  headerIcon="local_fire_department"
                  headerIconColor="scaleRed"
                  :footerBtnText="$t('book/dashboard:common.show-all-processes')"
                  :headers="processHeader"
                  rowThemeColor="scaleRed"
                  icon="open_in_new"
                  dependsOnProperty="checkin"
                  @clickedButton1="showGPSPermission($event)"
                  @updateTableData="updateUrgentUpcomingProcessTable"
                  sort-by="endDate"
                  as-button-property="facilityName"
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  @clickedRow="showProcessJob"
                  @clickedAsButton1="showFacility"
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- Upcoming Processes -->
            <v-col cols="12" md="6">
              <ExpansionPanelDataTablePaginated
                  ref="upcomingProcesses"
                  :headerTextFirstRow="$t('book/dashboard:home.upcoming-process')"
                  :headerTextSecondRow="$t('common:process_plural')"
                  :footerBtnText="$t('book/dashboard:common.show-all-processes')"
                  :headers="processHeader"
                  rowThemeColor="grey"
                  icon="open_in_new"
                  dependsOnProperty="checkin"
                  dependOnPropertyAltBadge="future"
                  @clickedButton1="showGPSPermission($event)"
                  @updateTableData="updateUpcomingProcessTable"
                  sort-by="endDate"
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  @clickedRow="showProcessJob"
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>

            <!-- Finished Processes / Process Results -->
            <v-col cols="12" md="6">
              <ExpansionPanelDataTablePaginated
                  ref="finishedProcesses"
                  :headerTextFirstRow="$t('book/dashboard:home.finished-process')"
                  :headerTextSecondRow="$t('common:process_plural')"
                  :footerBtnText="$t('book/dashboard:common.show-all-processes')"
                  :headers="finishedProcessHeader"
                  rowThemeColor="grey"
                  checkboxOnProperty="status"
                  @updateTableData="updateFinishedProcessTable"
                  sort-by="formattedDate"
                  sort-desc
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  @clickedRow="showProcessResult"
              />
            </v-col>
          </v-row>
          <v-row v-if="isAdmin">
            <DashboardTable />
          </v-row>

          <!-- TODO: uncomment when facility/building tasks have been implemented -->
          <!--
                    <v-row>
                      <v-col cols="12" md="6">

                                      <ExpansionPanelDataTablePaginated
                                          ref="buildingScoreTable"
                                          footerBtnText="Alle Gebäude anzeigen"
                                          :headers="scoreHeader"
                                          @updateTableData="updateBuildingScoreTable"
                                          rowThemeColor="grey"
                                          sort-by="taskName"
                                          icon="open_in_new"
                                          headerTextFirstRow="Gebäude"
                                          headerTextSecondRow="sind vollständig regristriert"
                                          is-score-header
                                          :headerScoreObject="dummyBuildingScoreObject"
                                          header-score-icon="building"
                                          header-score-width="40%"
                                          @toggleAllData="$router.push('/buildings')"
                                      />
                                    </v-col>

                                  <v-col cols="12" md="6">
                                      <ExpansionPanelDataTablePaginated
                                          ref="facilityScoreTable"
                                          footerBtnText="Alle Anlagen anzeigen"
                                          :headers="scoreHeader"
                                          @updateTableData="updateFacilityScoreTable"
                                          rowThemeColor="grey"
                                          sort-by="taskName"
                                          icon="open_in_new"
                                          headerTextFirstRow="Anlagen"
                                          headerTextSecondRow="sind vollständig regristriert"
                                          is-score-header
                                          :headerScoreObject="dummyBuildingScoreObject"
                                          header-score-icon="facility"
                                          header-score-width="40%"
                                          @toggleAllData="$router.push('/facilities')"
                                      />
                                    </v-col>
                                  </v-row>-->
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row justify="center" class="home-invitations pa-5 pa-md-0">
      <v-col cols="12" md="10" xl="8">
        <v-expansion-panels flat tile multiple>

          <h5 v-if="isManager || isOperator" class="mb-0 mt-3 greyBold--text font-weight-bold">{{ $t('book/dashboard:home.titles.facility-invitations') }}</h5>
          <v-row>
            <v-col cols="12" v-if="isMain">
              <!-- User-Invitations -->
              <ExpansionPanelDataTablePaginated
                  ref="userInvitationTable"
                  headerTextFirstRow="User"
                  :headerTextSecondRow="$t('book/dashboard:common.invitations')"
                  :footerBtnText="$t('book/dashboard:common.show-all-invitations')"
                  :headers="userInvitationHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  icon="send"
                  :iconTooltip="$t('book/dashboard:home.send-mail')"
                  @updateTableData="updateOpenUserInvitations"
                  sort-by="name"
                  sort-desc
                  panel-color="primary"
                  @clickedButton1="resendRegistryMail"
                  @clickedRow="viewUser"
                  show-table-default-footer
                  hide-toggle-all-btn
              />
            </v-col>

            <v-col cols="12" xl="6" v-if="isManager || isOperator">
              <!-- Process-Invitations of all facilities of customer-->
              <ExpansionPanelDataTablePaginated
                  ref="processCustomerInvitationTable"
                  :headerTextFirstRow="$t('common:process')"
                  :headerTextSecondRow="$t('book/dashboard:common.invitations')"
                  :footerBtnText="$t('book/dashboard:common.show-all-invitations')"
                  :headers="customerProcessHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  @updateTableData="updateCustomerProcessInvitationTable"
                  sort-by="endDate"
                  sort-desc
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  panel-color="primary"
                  @clickedRow="showProcessJob"
                  show-table-default-footer
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>

            <v-col cols="12" xl="6" v-if="isManager || isOperator">
              <!-- Role-Invitations of all facilities of customer-->
              <ExpansionPanelDataTablePaginated
                  ref="roleCustomerInvitationTable"
                  :headerTextFirstRow="$t('common:role_plural')"
                  :headerTextSecondRow="$t('book/dashboard:common.invitations')"
                  :footerBtnText="$t('book/dashboard:common.show-all-invitations')"
                  :headers="customerRoleHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  @updateTableData="updateCustomerRoleInvitationTable"
                  sort-by="facilityName"
                  sort-desc
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  panel-color="primary"
                  show-table-default-footer
                  @clickedRow="viewRoleInvitations"
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>
          </v-row>

          <h5 class="mb-0 mt-3 greyBold--text font-weight-bold">{{ $t('book/dashboard:home.titles.personal-invitations') }}</h5>
          <v-row>
            <!-- Process invitations -->
            <v-col cols="12" md="6">
              <ExpansionPanelDataTablePaginated
                  ref="processInvitationTable"
                  :headerTextFirstRow="$t('common:process')"
                  :headerTextSecondRow="$t('book/dashboard:common.invitations')"
                  :footerBtnText="$t('book/dashboard:common.show-all-invitations')"
                  :headers="processHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  icon="check"
                  icon2="close"
                  dependsOnProperty="checkin"
                  depends-on-property2="checkin"
                  @updateTableData="updateProcessInvitationTable"
                  sort-by="endDate"
                  sort-desc
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  panel-color="primary"
                  @clickedButton1="acceptInvitation($event, true, false)"
                  @clickedButton2="rejectInvitation($event, true, false)"
                  @clickedRow="showProcessJob"
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>

            <!-- Role invitations -->
            <v-col cols="12" md="6">
              <ExpansionPanelDataTablePaginated
                  ref="roleInvitationTable"
                  :headerTextFirstRow="$t('common:role_plural')"
                  :headerTextSecondRow="$t('book/dashboard:common.invitations')"
                  :footerBtnText="$t('book/dashboard:common.show-all-invitations')"
                  :headers="roleHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  icon="check"
                  icon2="close"
                  @updateTableData="updateRoleInvitationTable"
                  sort-by="roleName"
                  sort-desc
                  @toggleAllData="$router.push(`/${$store.state.manager.bookModuleUrl}/processes`)"
                  panel-color="primary"
                  @clickedButton1="acceptInvitation($event, false, true)"
                  @clickedButton2="rejectInvitation($event, false, true)"
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>

          </v-row>
          <h5 class="mb-0 mt-3 greyBold--text font-weight-bold">{{ $t('book/dashboard:home.titles.open-signatures') }}</h5>
          <v-row>
            <!-- Personal Signatures -->
            <v-col cols="12" md="6">
              <ExpansionPanelDataTablePaginated
                  ref="roleSignatureTable"
                  :headerTextFirstRow="$t('book/dashboard:home.personal')"
                  :headerTextSecondRow="$t('book/dashboard:home.signaturePending')"
                  :headers="isAdmin ? personalSignatureHeaderAdmin : personalSignatureHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  icon="check"
                  icon2="close"
                  @updateTableData="updateSignatureTable"
                  sort-desc
                  panel-color="primary"
                  show-table-default-footer
                  hide-toggle-all-btn
                  @clickedRow="viewPersonalDocumentation"
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>

            <!-- Open Signatures for all facilities of a customer -->
            <v-col cols="12" md="6">
              <ExpansionPanelDataTablePaginated
                  v-if="isManager"
                  ref="roleSignatureTableAdmin"
                  :headerTextFirstRow="$t('common:facility_plural')"
                  :headerTextSecondRow="$t('book/dashboard:home.signaturePending')"
                  :headers="customerSignatureHeader"
                  rowThemeColor="primary"
                  count-color="white"
                  icon="check"
                  icon2="close"
                  @updateTableData="updateCustomerSignatureTable"
                  sort-desc
                  panel-color="primary"
                  show-table-default-footer
                  hide-toggle-all-btn
                  @clickedRow="viewCustomerDocumentation"
                  as-button-property="facilityName"
                  @clickedAsButton1="showFacility"
              />
            </v-col>
          </v-row>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <TwoButtonDialog
        ref="checkGPSPermission"
        :hide-button="true"
        :dialog-title="$t('common:gps-control')"
        :dialog-text="$t('book/dashboard:home.gps-dialog')"
        :button1-text="$t('buttons:accept')"
        :button2-text="$t('buttons:decline')"
        @clickedButton1="checkUserLocation($event)"
        @clickedButton2="startProcessJob($event, false)"
    />

    <ProcessResultDialog ref="processResultDialog"/>
    <ProcessShowDialog ref="processShowDialog" hide-user/>
    <DocumentViewer hide-overlay ref="documentViewer"/>
    <ExternalFacilityDialog ref="facilityDialog"/>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import ExpansionPanelDataTablePaginated from '@/modules/core/components/DataTable/ExpansionPanelDataTablePaginated';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import FacilityService from '@/modules/book/services/facility-service';
import DataUtils from '@/modules/core/services/data-utils';
import Facility from '@/modules/book/data/facility';
import GPSUtils from '@/modules/core/services/gps-utils';
import Utils from '@/modules/core/services/utils';
import ProcessJobService from '@/modules/book/services/process/impl/process-job-service';
import DashboardWorkerService from '@/modules/book/services/dashboards/dashboard-worker-service';
import DashboardHomeService from '@/modules/book/services/dashboards/dashboard-home-service';
import FacilityUserAssignmentService from '@/modules/book/services/facility-user-assignment-service';
import ProcessResultDialog from '@/modules/book/components/Process/ProcessResultDialog';
import ProcessShowDialog from '@/modules/book/components/Process/ProcessShowDialog';
import DateUtils from '@/modules/core/services/date-utils';
import UsersService from '@/modules/core/services/users-service';
import DocumentViewer from '@/modules/core/components/DocumentViewer/DocumentViewer';
import ExternalFacilityDialog from '@/modules/book/components/Facility/ExternalFacilityDialog';
import DashboardTable from '@/modules/book/views/task/DashboardTable.vue';
import {is} from "date-fns/locale";

export default {
  name: 'HomePage',
  components: {
    DashboardTable,
    ExternalFacilityDialog,
    DocumentViewer, ProcessShowDialog, ProcessResultDialog, TwoButtonDialog, ExpansionPanelDataTablePaginated},
  data() {
    return {
      urgentProcesses: {
        options: [],
        search: []
      },
      upcomingProcesses: {
        options: [],
        search: []
      },
      processInvitations: {
        options: [],
        search: []
      },
      customerProcessInvitations: {
        options: [],
        search: []
      },
      roleInvitations: {
        options: [],
        search: []
      },
      customerRoleInvitations: {
        options: [],
        search: []
      },
      userInvitations: {
        options: [],
        search: []
      },
      personalSignatures: {
        options: [],
        search: []
      },
      customerSignatures: {
        options: [],
        search: []
      },
      personalDocuments: [],
      allDocuments: [],
      toggleAccess: this.own,
      own: 1,
      all: 2
    }
  },
  methods: {
    showFacility(item) {
      let facilityId;
      if (item.facility) {
        facilityId = item.facility;
      } else if (item.facilityId) {
        facilityId = item.facilityId;
      }

      if (this.isWorker) {
        // show basic facility dialog
        this.$refs.facilityDialog.initDialog(facilityId);
      } else {
        // route to facility
        this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${facilityId}`)
      }
    },

    // view uploaded documentations in documentation viewer
    viewPersonalDocumentation(item) {
      this.$refs.documentViewer.initViewerById(this.personalDocuments, item.id, item.facilityId, item.documentType);
    },

    viewCustomerDocumentation(item) {
      this.$refs.documentViewer.initViewerById(this.allDocuments, item.id, item.facilityId, item.documentType);
    },

    formatSignatureResultAndPushDocuments(items, personal) {
      if (items.length > 0) {
        items.forEach((item) => {
          item.translatedDocuType = this.$t('enums:facility-documentation-types.' + item.type);
          item.formattedDate = DateUtils.parseDateTimeForDisplay(item.savedOn);

          if (personal) {
            this.personalDocuments.push(item)
          } else {
            this.allDocuments.push(item)
          }
        })
      }
    },

    showGPSPermission(item) {
      this.$refs.checkGPSPermission.showDialog = true;
      this.$refs.checkGPSPermission.propToGiveThrough = item;
      this.$store.commit("book/process/storeRideCount", null);
      this.$store.commit("book/process/storeFileNumber", null);
    },

    updateUrgentUpcomingProcessTable(options, search) {
      if (!search) search = '';

      this.urgentProcesses.options = options;
      this.urgentProcesses.search = search;

      DashboardWorkerService.readAllPageableUrgentProcessInfo(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            resp.data.content.forEach((job) => {
              if (job.checkin) {
                job.taskStatus = 'open';
                job.id = job.jobId;
              }
            })
            this.$refs.urgentProcesses.fillTableData(resp.data)
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.urgent-process')}))
            this.$logger.error(error);
          }
      )
    },

    updateUpcomingProcessTable(options, search) {
      if (!search) search = '';

      this.upcomingProcesses.options = options;
      this.upcomingProcesses.search = search;

      DashboardWorkerService.readAllPageableProcessInfo(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            resp.data.content.forEach((job) => {
              if (job.checkin) {
                job.taskStatus = 'open';
                job.id = job.jobId;
              }
            })
            this.$refs.upcomingProcesses.fillTableData(resp.data)
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.upcoming-process')}))
            this.$logger.error(error);
          }
      )
    },

    updateFinishedProcessTable(options, search) {
      if (!search) search = '';

      DashboardWorkerService.readAllPageableFinishedProcesses(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            resp.data.content.forEach((job) => {
              job.formattedDate = DateUtils.parseDateTimeForDisplay(job.date);
            })
            this.$refs.finishedProcesses.fillTableData(resp.data)
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.finished-process')}))
            this.$logger.error(error);
          }
      )
    },

    updateProcessInvitationTable(options, search) {
      if (!search) search = '';

      this.processInvitations.options = options;
      this.processInvitations.search = search;

      DashboardWorkerService.readAllPageableProcessInvitations(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            resp.data.content.forEach((job) => {
              job.id = job.jobId;
              job.taskStatus = 'unassigned';
            })
            this.$refs.processInvitationTable.fillTableData(resp.data)
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.process-invitation')}))
            this.$logger.error(error);
          }
      )
    },

    updateSignatureTable(options, search) {
      if (!search) search = '';

      this.personalSignatures.options = options;
      this.personalSignatures.search = search;

      DashboardHomeService.readAllPageableSignatures(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            this.formatSignatureResultAndPushDocuments(resp.data.content, true);
            this.$refs.roleSignatureTable.fillTableData(resp.data)
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.signatures')}))
            this.$logger.error(error);
          }
      )
    },

    updateCustomerSignatureTable(options, search) {
      if (!search) search = '';

      this.customerSignatures.options = options;
      this.customerSignatures.search = search;

      if (this.toggleAccess === this.own) {
        DashboardHomeService.readAllPageableSignaturesByAssignedFacility(
            options.page - 1,
            options.itemsPerPage,
            search,
            options.sortBy,
            options.sortDesc,
            (resp) => {
              this.formatSignatureResultAndPushDocuments(resp.data.content, false);
              this.$refs.roleSignatureTableAdmin.fillTableData(resp.data)
            },
            (error) => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.signatures')}))
              this.$logger.error(error);
            }
        )
      } else {
        DashboardHomeService.readAllPageableSignaturesByCustomer(
            options.page - 1,
            options.itemsPerPage,
            search,
            options.sortBy,
            options.sortDesc,
            (resp) => {
              this.formatSignatureResultAndPushDocuments(resp.data.content, false);
              this.$refs.roleSignatureTableAdmin.fillTableData(resp.data)
            },
            (error) => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.signatures')}))
              this.$logger.error(error);
            }
        )
      }
    },


    updateRoleInvitationTable(options, search) {
      if (!search) search = '';

      this.roleInvitations.options = options;
      this.roleInvitations.search = search;

      DashboardHomeService.readAllPageableUsersRoleInvitations(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            this.$refs.roleInvitationTable.fillTableData(resp.data)
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.role-invitation')}))
            this.$logger.error(error);
          }
      )
    },

    updateOpenUserInvitations(options, search) {
      if (!search) search = '';

      this.userInvitations.options = options;
      this.userInvitations.search = search;

      DashboardHomeService.readAllPageableUserInvitations(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (resp) => {
            this.$refs.userInvitationTable.fillTableData(resp.data);
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.user-invitation')}))
            this.$logger.error(error);
          }
      )
    },

    updateCustomerProcessInvitationTable(options, search) {
      if (!search) search = '';

      this.customerProcessInvitations.options = options;
      this.customerProcessInvitations.search = search;

      if (this.toggleAccess === this.own) {
        DashboardHomeService.readFacilityAssignedProcessInvitations(
            options.page - 1,
            options.itemsPerPage,
            search,
            options.sortBy,
            options.sortDesc,
            (resp) => {
              resp.data.content.forEach((item) => {
                item.taskStatus = 'job-open-valid';
              })
              this.$refs.processCustomerInvitationTable.fillTableData(resp.data);
            },
            (error) => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.customer-process-invitation')}))
              this.$logger.error(error);
            }
        )
      } else {
        DashboardHomeService.readCustomerProcessInvitations(
            options.page - 1,
            options.itemsPerPage,
            search,
            options.sortBy,
            options.sortDesc,
            (resp) => {
              resp.data.content.forEach((item) => {
                item.taskStatus = 'job-open-valid';
              })
              this.$refs.processCustomerInvitationTable.fillTableData(resp.data);
            },
            (error) => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.customer-process-invitation')}))
              this.$logger.error(error);
            }
        )
      }
    },

    updateCustomerRoleInvitationTable(options, search) {
      if (!search) search = '';

      this.customerRoleInvitations.options = options;
      this.customerRoleInvitations.search = search;

      if (this.toggleAccess === this.own) {
        DashboardHomeService.readFacilityAssignedRoleInvitations(
            options.page - 1,
            options.itemsPerPage,
            search,
            options.sortBy,
            options.sortDesc,
            (resp) => {
              this.$refs.roleCustomerInvitationTable.fillTableData(resp.data);
            },
            (error) => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.customer-role-invitation')}))
              this.$logger.error(error);
            }
        )
      } else {
        DashboardHomeService.readCustomerRoleInvitations(
            options.page - 1,
            options.itemsPerPage,
            search,
            options.sortBy,
            options.sortDesc,
            (resp) => {
              this.$refs.roleCustomerInvitationTable.fillTableData(resp.data);
            },
            (error) => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/dashboard:home.snackbar.customer-role-invitation')}))
              this.$logger.error(error);
            }
        )
      }
    },

    checkUserLocation(item) {
      FacilityService.readFromAPI(item.facilityId,
          (resp) => {
            var response = DataUtils.parseDataToSingleObject(resp.data, Facility);
            var buildingLat = response.buildingLatitude;
            var buildingLng = response.buildingLongitude;

            this.$getLocation({
              enableHighAccuracy: true,
            }).then(coordinates => {
              var userLat = coordinates.lat;
              var userLng = coordinates.lng;

              var distance = GPSUtils.calcDistance(userLat, userLng, buildingLat, buildingLng);
              if (distance == -1) {
                Utils.showFailureSnackbar(this.$t('utils:gps.missing-value'))
              }
              if (distance < process.env.VUE_APP_CHECK_IN_LOCATION_RADIUS) {
                this.startProcessJob(item, true);
              } else {
                this.$refs.checkGPSPermission.showDialog = false;
                Utils.showFailureSnackbar(this.$t('utils:gps.distance-error'))
              }
            }).catch((error) => {
              this.$logger.info("Could not access GPS data, because: " + error);
              Utils.showFailureSnackbar(this.$t('utils:gps.access-error'))
            });
          }
      )
    },

    startProcessJob(item, gpsCheck) {
      // TODO save users decicion on GPS Check in backend
      if (gpsCheck) {
        this.acceptedGPSCheck = true;
      } else {
        this.acceptedGPSCheck = false;
      }

      ProcessJobService.startProcessJob(item.jobId, this.acceptedGPSCheck,
          () => {
            this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/process/${item.jobId}`);
          },
          (error) => {
            this.$logger.info("Error at starting Process Job: " + error);
          }
      )
    },

    acceptInvitation(item, isProcessInvitation, isRoleInvitation) {
      if (isProcessInvitation && !isRoleInvitation) {
        ProcessJobService.acceptProcessJob(item.jobId,
            () => {
              this.updateProcessInvitationTable(this.processInvitations.options, this.processInvitations.search);
              this.updateUrgentUpcomingProcessTable(this.urgentProcesses.options, this.urgentProcesses.search);
              this.updateUpcomingProcessTable(this.upcomingProcesses.options, this.upcomingProcesses.search);
              Utils.showSuccessSnackbar(this.$t('book/dashboard:home.snackbar.accept-process'));
            },
            (error) => {
              this.$logger.info("Error at accepting Process Job: " + error);
            }
        )
      } else if (isRoleInvitation && !isProcessInvitation) {
        FacilityUserAssignmentService.acceptRoleInvitation(item.id,
            () => {
              this.updateRoleInvitationTable(this.roleInvitations.options, this.roleInvitations.search);
              Utils.showSuccessSnackbar(this.$t('book/dashboard:home.snackbar.accept-role'));
            },
            (error) => {
              this.$logger.error("Error at accepting Role Invitation: " + error);
            }
        )
      }
    },

    rejectInvitation(item, isProcessInvitation, isRoleInvitation) {
      if (isProcessInvitation && !isRoleInvitation) {
        ProcessJobService.rejectProcessJob(item.jobId,
            () => {
              this.updateProcessInvitationTable(this.processInvitations.options, this.processInvitations.search);
              Utils.showSuccessSnackbar(this.$t('book/dashboard:home.snackbar.reject-process'));
            },
            (error) => {
              this.$logger.info("Error at accepting Process Job: " + error);
            }
        )
      } else if (isRoleInvitation && !isProcessInvitation) {
        FacilityUserAssignmentService.rejectRoleInvitation(item.id,
            () => {
              this.updateRoleInvitationTable(this.roleInvitations.options, this.roleInvitations.search);
              Utils.showSuccessSnackbar(this.$t('book/dashboard:home.snackbar.reject-role'));
            },
            (error) => {
              this.$logger.error("Error at accepting Role Invitation: " + error);
            }
        )
      }
    },

    showProcessJob(item) {
      this.$refs.processShowDialog.openDialog(item)
    },

    showProcessResult(item) {
      this.$refs.processResultDialog.openDialog(item)
    },

    resendRegistryMail(item) {
      let roleName = this.$t('enums:hierarchy.' + item.bookHierarchy);

      UsersService.resendRegisterMail(item.id, roleName,
          () => {
            Utils.showSuccessSnackbar(this.$t('book/dashboard:home.snackbar.send-mail-success', {mail: item.email}))
          },
          (serviceName, error) => {
            if (error.response.headers.error_cause && this.$t('error-causes:' + error.response.headers.error_cause)) {
              Utils.showFailureSnackbar(this.$t("error-causes:" + error.response.headers.error_cause));
            } else {
              Utils.showFailureSnackbar(this.$t('book/dashboard:home.snackbar.send-mail-failed', {mail: item.email}));
            }
          }
      )
    },

    viewUser(item) {
      this.$router.push(`/${this.$store.state.manager.settingsModuleUrl}/profile/customer/users?user=${item.id}`)
    },

    viewRoleInvitations(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${item.facility}/info/roles`)
    },

    reloadTables() {
      this.$store.commit('book/dashboardHome/storeToggleAccess', this.toggleAccess);

      this.updateCustomerProcessInvitationTable(this.customerProcessInvitations.options, this.customerProcessInvitations.search);
      this.updateCustomerRoleInvitationTable(this.customerRoleInvitations.options, this.customerRoleInvitations.search);
      this.updateCustomerSignatureTable(this.customerSignatures.options, this.customerSignatures.search);
    }
  },
  computed: {
    is() {
      return is
    },
    ...mapGetters('auth', ['isOperator', 'isManager', 'isMain', 'isWorker', 'isAdmin']),

    currentUser() {
      return this.$store.state.auth.user;
    },

    processHeader() {
      return [
        {text: this.$t('common:facility'), value: 'asButton'},
        {text: this.$t('common:process'), value: "processName"},
        {text: this.$t('common:end-date'), value: "endDate"},
        {text: "Check-In", value: "controls", sortable: false},
      ]
    },

    customerProcessHeader() {
      return [
        {text: this.$t('common:facility'), value: 'asButton'},
        {text: this.$t('common:process'), value: "processName"},
        {text: this.$t('common:end-date'), value: "endDate"},
        {text: this.$t('book/dashboard:home.assigned-to-name'), value: 'assignedToName'},
        {text: this.$t('book/dashboard:home.assigned-to-mail'), value: 'assignedToMail'}
      ]
    },

    finishedProcessHeader() {
      return [
        {text: this.$t('common:process'), value: "processName"},
        {text: this.$t('common:date'), value: "formattedDate"},
        {text: this.$t('common:status'), value: "checkbox"}
      ]
    },
    roleHeader() {
      return [
        {text: this.$t('common:facility'), value: "asButton"},
        {text: this.$t('common:role'), value: "roleName"},
        {text: "Check-In", value: "controls", sortable: false}
      ]
    },

    customerRoleHeader() {
      return [
        {text: this.$t('common:facility'), value: "asButton"},
        {text: this.$t('common:role'), value: "roleName"},
        {text: this.$t('book/dashboard:home.assigned-to-name'), value: 'userName'},
        {text: this.$t('book/dashboard:home.assigned-to-mail'), value: 'userEmail'}
      ]
    },

    userInvitationHeader() {
      return [
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:email'), value: 'email'},
        {text: '', value: 'controls', sortable: false}
      ]
    },
    personalSignatureHeaderAdmin() {
      return [
        {text: this.$t('common:facility'), value: "asButton"},
        {text: this.$t('common:document-name'), value: "name"},
        {text: this.$t('common:type'), value: "translatedDocuType"},
        {text: this.$t('common:date'), value: "formattedDate"},
        {text: this.$t('book/dashboard:home.assigned-to-name'), value: 'assignedToName'}
      ]
    },
    personalSignatureHeader() {
      return [
        {text: this.$t('common:facility'), value: "asButton"},
        {text: this.$t('common:document-name'), value: "name"},
        {text: this.$t('common:type'), value: "translatedDocuType"},
        {text: this.$t('common:date'), value: "formattedDate"}
      ]
    },
    customerSignatureHeader() {
      return [
        {text: this.$t('common:facility'), value: "asButton"},
        {text: this.$t('common:document-name'), value: "name"},
        {text: this.$t('common:type'), value: "translatedDocuType"},
        {text: this.$t('common:date'), value: "formattedDate"},
        {text: this.$t('book/dashboard:home.assigned-to-name'), value: 'assignedToName'}
      ]
    },
    scoreHeader() {
      return [
        {text: this.$t('book/dashboard:home.pending-task'), value: "taskName"},
        {text: this.$t('buttons:edit'), value: "controls", sortable: false}
      ]
    }
  },
  mounted() {
    if (!this.isWorker) {
      this.toggleAccess = this.$store.state.book.dashboardHome.toggleAccess != null ? this.$store.state.book.dashboardHome.toggleAccess : this.own;
    } else {
      this.toggleAccess = this.all;
    }
  }
}

</script>
<style src="./Home.scss" lang="scss"/>
